/**
 * storeCategories — single source of truth for "Ye Olde Store" categories.
 *
 * Adding a category is a one-line change here: no new page, no new route case.
 * `key` is what travels through navigation (setPage payload / AppRouter state).
 * A category with a non-empty `items` array renders the product grid;
 * an empty one renders the "coming soon" placeholder.
 *
 * `items` is prototype data. When the backend is ready, swap this for a
 * fetch keyed by category (see StoreCategoryPage's commented fetch stub).
 */
export const STORE_CATEGORIES = [
    {
        key: 'skins',
        label: 'Skins',
        items: [
            { id: 1, name: 'Skin 1', price: 500 },
            { id: 2, name: 'Skin 2', price: 750 },
            { id: 3, name: 'Skin 3', price: 1000 },
            { id: 4, name: 'Skin 4', price: 500 },
            { id: 5, name: 'Skin 5', price: 1200 },
            { id: 6, name: 'Skin 6', price: 800 },
            { id: 7, name: 'Skin 7', price: 600 },
            { id: 8, name: 'Skin 8', price: 900 }
        ]
    },
    { key: 'backgrounds', label: 'Backgrounds', items: [] },
    { key: 'foils', label: 'Foils', items: [] },
    { key: 'taunts', label: 'Taunts', items: [] }
];

// Fast lookup by key, e.g. STORE_CATEGORY_MAP.skins
export const STORE_CATEGORY_MAP = STORE_CATEGORIES.reduce((acc, c) => {
    acc[c.key] = c;
    return acc;
}, {});
